import { render, staticRenderFns } from "./FolderStatus.vue?vue&type=template&id=7877e5b0&scoped=true"
import script from "./FolderStatus.vue?vue&type=script&lang=js"
export * from "./FolderStatus.vue?vue&type=script&lang=js"
import style0 from "./FolderStatus.vue?vue&type=style&index=0&id=7877e5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7877e5b0",
  null
  
)

export default component.exports